// extracted by mini-css-extract-plugin
export default {"thead":"thead__xEK0Y","heading":"heading__VVTra","label":"label__RoPAd","range":"range__hOa76"};